import MajorMedTab from "../../../../patient/details/majormed/MajorMedTab";

export default function MajorMedDrawerTab({classes, goToCaseTabHandler, column = 5, inWorkQ}) {
    return <div className={`${classes.block} ${classes[`block_${column}`]}`}>
        <MajorMedTab inWorkQ={inWorkQ} />
    </div>
}
